export default "__VITE_ASSET__0313335a__"